// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'

import { OptionWithData } from '../'


export const BankAccountOption = ({ id, bankName, accountNumber }) => (
  <OptionWithData
    value={id}
    forField='BankAccountBankName'
    searchKey={bankName}
    appendString={` - ${accountNumber}`}
  />
)

BankAccountOption.propTypes = {
  id: PropTypes.string.isRequired,
  bankName: PropTypes.string.isRequired,
  accountNumber: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/select-identity-bankaccount/BankAccountOption.js